import { PrincipalActionsButton } from '../Components';

export const onPrincipalActionsCellRender = (e, parentId) => {
    if (!parentId) {
        return null;
    } else {
        return (
            <PrincipalActionsButton
                data={e.data}
                parentId={parentId}
            />
        );
    }
};
